import styled from 'styled-components';

export const MapDisplayContainer = styled.div`
  margin: 25px 0;
  padding: 25px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  h3 {
    margin: 0 0 20px 0;
    color: #333;
    font-size: 24px;
    font-weight: 700;
  }

  .leaflet-container {
    border: 3px solid #e0e0e0;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    min-height: 400px;
    border-radius: 12px;
  }

  .location-info {
    margin-top: 20px;
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
  }

  .location-detail {
    padding: 14px 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 25px;
    font-size: 18px;
    font-weight: 600;
    display: inline-block;
  }

  @media (max-width: 768px) {
    padding: 20px;

    h3 {
      font-size: 18px;
    }

    .leaflet-container {
      min-height: 350px;
    }

    .location-detail {
      font-size: 14px;
      padding: 10px 16px;
    }
  }
`;
